import React from 'react';
import { Box } from 'theme-ui';
import CollapsiblePanel from '../CollapsiblePanel';
type Props = {
  item: Queries.KitPageFragmentFragment | Queries.BundlePageFragment | Queries.ProductPageFragmentFragment;
};
const PDPContent = ({ item }: Props) => {
  return (
    <>
      <Box>
        {item?.longDescription?.childMarkdownRemark?.html ? (
          <Box
            sx={{
              variant: 'text.copy',
              p: { m: 0 },
            }}
            dangerouslySetInnerHTML={{ __html: item.longDescription.childMarkdownRemark.html }}
          />
        ) : null}
      </Box>
      {item.contentSections &&
        item.contentSections.map((section, i) => (
          <CollapsiblePanel title={section?.title} key={section?.title} closedOnStart={i > 0 && true}>
            {section?.content?.childMarkdownRemark?.html && (
              <Box dangerouslySetInnerHTML={{ __html: section.content.childMarkdownRemark.html }} />
            )}
          </CollapsiblePanel>
        ))}
    </>
  );
};

export default PDPContent;
